import { TFunction } from "i18next";

import { IOptionItem } from "../../../formik/formik-autocomplete/FormikAutocomplete.types";
import { ProceedingParticipantType } from "../../api/ClientFileApi";

// Derived, never hand-listed: the enum is generated from the backend, so a type added there shows
// up in the dropdown on the next client generation instead of being silently omitted.
const ALL_TYPES: ProceedingParticipantType[] = Object.values(ProceedingParticipantType);

export function participantTypeLabels(t: TFunction): Record<string, string> {
  return {
    [ProceedingParticipantType.Creditor]: t("proceedingParticipants.types.Creditor"),
    [ProceedingParticipantType.LawFirm]: t("proceedingParticipants.types.LawFirm"),
    [ProceedingParticipantType.DebtCollectionAgency]: t("proceedingParticipants.types.DebtCollectionAgency"),
    [ProceedingParticipantType.Trustee]: t("proceedingParticipants.types.Trustee"),
    [ProceedingParticipantType.InsolvencyAdministrator]: t("proceedingParticipants.types.InsolvencyAdministrator"),
    [ProceedingParticipantType.Organisation]: t("proceedingParticipants.types.Organisation"),
    [ProceedingParticipantType.Bank]: t("proceedingParticipants.types.Bank"),
    [ProceedingParticipantType.Insurance]: t("proceedingParticipants.types.Insurance"),
  };
}

export function participantTypeOptions(t: TFunction, allowedTypes?: ProceedingParticipantType[]): IOptionItem[] {
  const labels = participantTypeLabels(t);
  const types = allowedTypes ?? ALL_TYPES;
  return types.map((type) => ({ id: type, label: labels[type] ?? type }));
}
